exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-bangers-js": () => import("./../../../src/pages/bangers.js" /* webpackChunkName: "component---src-pages-bangers-js" */),
  "component---src-pages-boys-js": () => import("./../../../src/pages/boys.js" /* webpackChunkName: "component---src-pages-boys-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-nomination-js": () => import("./../../../src/pages/nomination.js" /* webpackChunkName: "component---src-pages-nomination-js" */)
}

